// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__2mVZD","info":"PatientInfo_info__w6K9K"};